import { render, staticRenderFns } from "./ControlAction.vue?vue&type=template&id=2d1f41a8&scoped=true&"
import script from "./ControlAction.vue?vue&type=script&lang=js&"
export * from "./ControlAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1f41a8",
  null
  
)

export default component.exports